import { z } from "zod";
import { OmitStrict } from "../../utils";

export const AssetType = z.enum(["Image", "Font", "Generic"]);
export const AssetScope = z.enum([
  "DocumentationFrame",
  "ComponentThumbnail",
  "DesignSystem",
  "Documentation",
  "DocumentationEmbed",
]);

export const AssetFontProperties = z.object({
  family: z.string(),
  subfamily: z.string(),
});

export const AssetProperties = z.union([
  z.object({
    fontProperties: z.array(AssetFontProperties),
  }),
  z.object({
    width: z.number(),
    height: z.number(),
  }),
]);

export const AssetOrigin = z.object({
  originKey: z.string(),
});

export const Asset = z.object({
  id: z.string(),
  designSystemId: z.string().nullish(),
  type: AssetType,
  originalFileName: z.string().nullish(),
  filePath: z.string(),
  scope: AssetScope,
  properties: AssetProperties.nullish(),
  originKey: z.string().optional(),
  createdAt: z.coerce.date().optional(),
  pendingUpload: z.boolean().optional(),
  size: z.number().int().positive().optional(),
  checksum: z.string().optional(),
});

export const ResolvedAsset = Asset.extend({
  url: z.string(),
});

export type AssetType = z.infer<typeof AssetType>;
export type AssetScope = z.infer<typeof AssetScope>;
export type AssetFontProperties = z.infer<typeof AssetFontProperties>;
export type AssetProperties = z.infer<typeof AssetProperties>;
export type AssetOrigin = z.infer<typeof AssetOrigin>;
export type Asset = z.infer<typeof Asset>;
export type ResolvedAsset = z.infer<typeof ResolvedAsset>;

export type ImportedAsset = OmitStrict<Asset, "originKey"> & {
  originKey: string;
};

export function isImportedAsset(asset: Asset): asset is ImportedAsset {
  return !!asset.originKey;
}
